export default function Features() {
  const features = [
    {
      icon: 'ri-mail-check-line',
      title: 'Gestion intelligente des emails',
      description: 'Tri, priorisation et réponses automatiques selon vos directives'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Agenda & prise de rendez-vous',
      description: 'Planification optimisée et coordination automatique des réunions'
    },
    {
      icon: 'ri-phone-line',
      title: 'Appels et suivis automatisés',
      description: 'Relances systématiques et suivi des engagements pris'
    },
    {
      icon: 'ri-user-search-line',
      title: 'Qualification des leads',
      description: 'Identification et priorisation des opportunités commerciales'
    },
    {
      icon: 'ri-folder-line',
      title: 'Organisation des documents',
      description: 'Classement intelligent et accès instantané à l\'information'
    },
    {
      icon: 'ri-alarm-line',
      title: 'Rappels & priorités',
      description: 'Gestion proactive de vos échéances et engagements'
    },
    {
      icon: 'ri-file-chart-line',
      title: 'Résumés & reporting',
      description: 'Synthèses quotidiennes et analyses de performance'
    },
    {
      icon: 'ri-links-line',
      title: 'Intégration CRM / messageries',
      description: 'Connexion native avec vos outils professionnels'
    }
  ];

  return (
    <section id="fonctionnalites" className="py-24 px-6 relative">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-600/10 border border-blue-500/30 rounded-full mb-6">
            <span className="text-sm text-blue-300 whitespace-nowrap">Fonctionnalités</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Une suite complète pour
            <br />
            <span className="bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">
              votre efficacité exécutive
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Toutes les capacités d'un assistant exécutif senior, disponibles instantanément.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-sm border border-white/10 rounded-xl p-6 hover:border-blue-500/50 transition-all group cursor-pointer hover:transform hover:scale-105"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-blue-600/20 to-violet-600/20 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-2xl text-blue-400`}></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-violet-600/10 to-blue-600/10 border border-violet-500/30 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold mb-4">Comment ça fonctionne ?</h3>
          <div className="grid md:grid-cols-4 gap-6 mt-8">
            <div className="relative">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-violet-600 to-blue-600 rounded-full mx-auto mb-4 text-xl font-bold">1</div>
              <h4 className="font-semibold mb-2 whitespace-nowrap">Analyse de votre organisation</h4>
              <p className="text-sm text-gray-400">Audit de vos processus et besoins</p>
            </div>
            <div className="relative">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-violet-600 to-blue-600 rounded-full mx-auto mb-4 text-xl font-bold">2</div>
              <h4 className="font-semibold mb-2 whitespace-nowrap">Déploiement sur-mesure</h4>
              <p className="text-sm text-gray-400">Configuration personnalisée de l'IA</p>
            </div>
            <div className="relative">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-violet-600 to-blue-600 rounded-full mx-auto mb-4 text-xl font-bold">3</div>
              <h4 className="font-semibold mb-2 whitespace-nowrap">Connexion à vos outils</h4>
              <p className="text-sm text-gray-400">Intégration transparente</p>
            </div>
            <div className="relative">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-violet-600 to-blue-600 rounded-full mx-auto mb-4 text-xl font-bold">4</div>
              <h4 className="font-semibold mb-2 whitespace-nowrap">Optimisation continue</h4>
              <p className="text-sm text-gray-400">Amélioration permanente</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}